(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();
        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"] && !Shopify.designMode) return;
  try {
    
var section = document.querySelector(".recently-viewed-products");
if (section) {
  var currentHandle = section.dataset.currentHandle;
  if (currentHandle) {
    var viewed = JSON.parse(localStorage.getItem('recentlyViewed') || '[]');
    viewed = viewed.filter(function(h) { return h !== currentHandle; });
    viewed.push(currentHandle);
    if (viewed.length > 20) {
      viewed.shift();
    }
    localStorage.setItem('recentlyViewed', JSON.stringify(viewed));
  }
}

var loadRecentlyViewedIntoSection = function() {
  var section = document.querySelector(".recently-viewed-products");
  if (section === null) { return; }
  var viewed = JSON.parse(localStorage.getItem('recentlyViewed') || '[]');
  var currentHandle = section.dataset.currentHandle;
  if (currentHandle) {
    viewed = viewed.filter(function(h) { return h !== currentHandle; });
  }
  if (viewed.length === 0) { return; }
  var grid = parseInt(section.dataset.grid);
  viewed = viewed.slice(-grid).reverse();
  var query = viewed.join(',');
  var url = '/search?section_id=' + section.dataset.sectionId + '&q=' + encodeURIComponent(query) + '&type=product';
  var request = new XMLHttpRequest();
  request.open("GET", url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      section.innerHTML = container.querySelector(".recently-viewed-products").innerHTML;
    }
  };
  request.send();
};
loadRecentlyViewedIntoSection();
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].recently-viewed-products')) {
    loadRecentlyViewedIntoSection();
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
